import { useSelector } from 'react-redux';
import { routeParamsSelector } from '../../../../../CommonComponents/Router/Selector';

interface RouteParams {
  workflowId: string;
}

export const useRouteParams = (): RouteParams => useSelector(routeParamsSelector);
